// vault.js — the vault page, v3 (sections/vault.liquid, assets/vault.css).
// Three jobs, nothing else: the shop's promo prices, the offer picker (one
// key that follows the chosen offer, its contents shown below), the key
// (the cart cleared of what contradicts the offer, every version in, then
// the checkout). Plus the bar at the foot of a phone once the key is gone
// above the screen. No scroll listener, no animation.
(() => {
  const W = window, doc = document;
  const $ = (s, r = doc) => r.querySelector(s);
  const $$ = (s, r = doc) => Array.from(r.querySelectorAll(s));
  const fmt = (c) => { const D = W.DRAYKI; return D && typeof D.fmt === 'function' ? D.fmt(c) : null; };

  /* ------------------------------------------------- the shop's promo */
  // While it runs (start → end, at the visitor's clock, never a cached
  // page's), each price ([data-lpp], cents) is the better of the two, as in
  // the cart; each [data-pt] takes its promo text; the promo lines show.
  function promo(root, onChange) {
    const end = Date.parse(root.dataset.promoEnd || ''), start = Date.parse(root.dataset.promoStart || ''), off = +root.dataset.promoOff || 0;
    const now = Date.now();
    if (!(off > 0 && end && now < end)) return;
    const swap = [];
    for (const el of $$('[data-lpp]', root)) { const v = +el.dataset.lpp, t = fmt(v); if (t && isFinite(v) && v !== +el.dataset.lp) swap.push([el, el.textContent, t]); }
    for (const el of $$('[data-pt]', root)) swap.push([el, el.textContent, el.dataset.pt]);
    const only = $$('[data-promo-only]', root);
    const set = (on) => {
      for (const [el, a, b] of swap) el.textContent = on ? b : a;
      for (const el of only) el.hidden = !on;
      root.classList.toggle('promo', on);
      onChange();
    };
    const T = 2147483000;
    if (!(start > now)) set(true);
    else if (start - now < T) setTimeout(() => set(true), start - now + 500);
    if (end - now < T) setTimeout(() => set(false), end - now + 500);
  }

  for (const root of $$('[data-vault]')) {
    const radios = $$('input[name="vx-offer"]', root);
    const keys = $$('[data-vault-go]:not(input)', root);
    const sync = () => {
      const r = radios.find((x) => x.checked) || radios[0];
      if (!r) return;
      const on = root.classList.contains('promo');
      const price = fmt(+(on ? r.dataset.pp : r.dataset.p));
      for (const a of keys) {
        a.setAttribute('data-vault-go', r.getAttribute('data-vault-go'));
        a.setAttribute('data-vault-h', r.getAttribute('data-vault-h'));
        a.href = r.dataset.href;
      }
      const lb = $('[data-go-lb]', root); if (lb) lb.textContent = r.dataset.btn;
      for (const el of $$('[data-go-p], [data-bar-p]', root)) if (price) el.textContent = price;
      const bl = $('[data-bar-lb]', root); if (bl) bl.textContent = r.dataset.label;
      const il = $('[data-in-label]', root); if (il) il.textContent = r.dataset.label;
      for (const g of $$('[data-g]', root)) g.hidden = g.dataset.g !== r.value;
    };
    radios.forEach((r) => r.addEventListener('change', sync));
    promo(root, sync);
    sync();

    // the bar: up once the hero's key has gone above the screen (never over the cookie card)
    const bar = $('[data-vx-bar]', root), go = $('#vx-go', root);
    if (bar && go && 'IntersectionObserver' in W) {
      const b = $('a', bar);
      new IntersectionObserver((es) => {
        const e = es[es.length - 1];
        const on = !e.isIntersecting && e.boundingClientRect.top < 0 && !doc.getElementById('ck');
        bar.classList.toggle('on', on);
        if (b) b.tabIndex = on ? 0 : -1;
      }).observe(go);
    }
  }

  /* ----------------------------------------------------------- the key */
  // The lines of the cart that contradict the offer — another version of one
  // of its kits, one of its kits twice — go first; every other kit and halo
  // stay. Then every version of the offer (the pixel's AddToCart), then the
  // checkout. One press at a time; if the cart fails, the link.
  if (!W.__vltKeys) {
    W.__vltKeys = true;
    doc.addEventListener('click', (e) => {
      const a = e.target && e.target.closest ? e.target.closest('a[data-vault-go]') : null;
      if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const api = W.DRAYKI && W.DRAYKI.cart;
      if (!api || typeof api.addMany !== 'function' || typeof api.items !== 'function' || typeof api.remove !== 'function') return;
      e.preventDefault();
      if (a.getAttribute('aria-busy') === 'true') return;
      a.setAttribute('aria-busy', 'true');
      const ids = (a.getAttribute('data-vault-go') || '').split(',').filter(Boolean);
      const want = new Set(ids), hs = new Set((a.getAttribute('data-vault-h') || '').split(/\s+/).filter(Boolean));
      const root = a.closest('[data-vault]'), to = (root && root.dataset.checkout) || '/checkout';
      const kits = api.items().filter((i) => i.kit);
      const out = kits.filter((i) => hs.has(i.h) && (!want.has(String(i.vid)) || i.qty > 1));
      const clear = !out.length ? Promise.resolve()
        : out.length === 1 ? api.remove(out[0].key)
        : kits.every((i) => hs.has(i.h)) ? api.remove('vault')
        : out.reduce((p, i) => p.then(() => api.remove(i.key)), Promise.resolve());
      clear.then(() => api.addMany(ids)).then(() => { location.href = to; }, () => { location.href = a.href; });
    });
    W.addEventListener('pageshow', () => { for (const a of $$('[data-vault-go][aria-busy]')) a.removeAttribute('aria-busy'); });
  }
})();
